import { ReactElement, useCallback } from 'react'
import { Box } from '@mui/material'

interface Props {
  host: HTMLDivElement
}

/**
 * Shows the session's chat host (`createChatHost`) here by moving its DOM
 * node in. The chat itself stays mounted where it is rendered, so moving it
 * between surfaces keeps its state; the ref is stable, so the node is moved
 * once per mount, not on every render.
 */
const ChatHostOutlet = ({ host }: Props): ReactElement => {
  const attachHost = useCallback(
    (element: HTMLDivElement | null) => {
      element?.appendChild(host)
    },
    [host],
  )

  return (
    <Box
      ref={attachHost}
      sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
    />
  )
}

export default ChatHostOutlet
